import React from 'react';

const FieldMappingsConfig = ({
  fieldMappings,
  defaultValues,
  loading,
  selectedEntityType,
  setSelectedEntityType,
  fetchFieldMappings,
  fetchDefaultValues
}) => {
  const handleRefresh = () => {
    fetchFieldMappings();
    fetchDefaultValues();
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div className="header-left">
          <h2>Field Configuration</h2>
          <p>HubSpot to Autotask field mappings and default values (read-only)</p>
        </div>
        <div className="header-actions">
          <select
            value={selectedEntityType}
            onChange={(e) => setSelectedEntityType(e.target.value)}
            className="entity-select"
          >
            <option value="Company">Company</option>
            <option value="Contact">Contact</option>
          </select>
          <button onClick={handleRefresh} className="btn btn-secondary" disabled={loading}>
            {loading ? 'Loading...' : 'Refresh'}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Autotask Field</th>
                <th>HubSpot Field</th>
                <th>Data Type</th>
                <th>Default Value</th>
              </tr>
            </thead>
            <tbody>
              {fieldMappings.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-data">No field mappings found</td>
                </tr>
              ) : (
                fieldMappings.map((mapping) => {
                  const defaultVal = defaultValues.find(d => d.autotask_field_id === mapping.autotask_field_id);
                  // Special case: companyName uses HubSpot ID as fallback
                  const getDefaultDisplay = () => {
                    if (mapping.autotask_field_id === 'companyName') {
                      return 'Hubspot Company (ID)';
                    }
                    return defaultVal ? defaultVal.default_value : null;
                  };
                  const defaultDisplay = getDefaultDisplay();
                  return (
                    <tr key={mapping.id} className={!mapping.is_active ? 'inactive' : ''}>
                      <td>
                        <span className={`status-badge ${mapping.is_active ? 'success' : 'error'}`}>
                          {mapping.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <strong>{mapping.autotask_field_id}</strong>
                        {mapping.autotask_field_name && (
                          <>
                            <br />
                            <small className="text-muted">{mapping.autotask_field_name}</small>
                          </>
                        )}
                      </td>
                      <td>
                        <strong>{mapping.hubspot_field_id}</strong>
                        {mapping.hubspot_field_name && (
                          <>
                            <br />
                            <small className="text-muted">{mapping.hubspot_field_name}</small>
                          </>
                        )}
                      </td>
                      <td>
                        <span className="type-badge">{mapping.field_data_type}</span>
                      </td>
                      <td>
                        {defaultDisplay ? (
                          <code style={{
                            background: '#1f2937',
                            color: '#10b981',
                            padding: '2px 8px',
                            borderRadius: 4,
                            fontSize: 13
                          }}>{defaultDisplay}</code>
                        ) : '-'}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

          <div style={{
            marginTop: 24,
            padding: 16,
            background: '#f8f9fa',
            borderRadius: 8,
            border: '1px solid #e9ecef'
          }}>
            <h4 style={{margin: '0 0 8px 0', fontSize: 14, color: '#495057'}}>How Field Mappings Work</h4>
            <p style={{margin: 0, fontSize: 13, color: '#6c757d', lineHeight: 1.6}}>
              When a record is synced from HubSpot to Autotask, these mappings determine which HubSpot fields
              are copied to which Autotask fields. If a HubSpot field is empty, the default value shown is used instead.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FieldMappingsConfig;
